<template>
    <div :class="['sidebar', { expanded }]">
        <div class="sidebar-inner">
            <div class="sidebar-logo">
                <a href="#">
                    <img src="../../assets/images/logo.svg" alt="Navigation - Logo" />
                </a>
                <div class="app-version">
                    <span v-if="expanded">Version:</span>
                    <span v-else>v</span>{{appVersion}}
                </div>
            </div>
            <ul class="sidebar-navigation">
                <!--<li class="sidebar-nav-item">
                    <a href="#">
                        <img src="../../assets/images/nav-home.svg" alt="Navigation - Home" />
                        <span>Home</span>
                    </a>
                </li>-->
                <li class="sidebar-nav-item" :class="{selected: selectedSection == 'charts'}" :title="!expanded ? 'Charts' : false">
                    <a href="#">
                        <svg class="ico" width="20px" height="18px">
                            <use xlink:href="#ico-menu-charts"></use>
                        </svg>
                        <span>Charts</span>
                    </a>
                </li>
                <!--<li class="sidebar-nav-item">
                    <a href="#">
                        <img src="../../assets/images/nav-profile.svg" alt="Navigation - Profile" />
                        <span>Profile</span>
                    </a>
                </li>
                -->
                <li class="sidebar-nav-item" :class="{selected: selectedSection == 'settings'}" :title="!expanded ? 'Settings' : false"> 
                    <a href="#" @click.prevent="openSettings">
                        <svg class="ico" width="20px" height="20px">
                            <use xlink:href="#ico-menu-settings"></use>
                        </svg>
                        <span>Settings</span>
                    </a>
                </li>
                <li class="sidebar-nav-item" :title="!expanded ? 'Logout' : false">
                    <a href="#" @click.prevent="logout">
                        <svg class="ico has--stroke" width="20px" height="20px">
                            <use xlink:href="#ico-menu-logout"></use>
                        </svg>
                        <span>Logout</span>
                    </a>
                </li>
            </ul>
            <div class="sidebar-expand">
                <a href="#" @click="toggleExpand">
                    <svg class="ico" width="9px" height="9px">
                        <use xlink:href="#ico-sidebar-expand"></use>
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from '../../main'

export default {
    data() {
        return {
            expanded: false,
            appVersion:  process.env.VUE_APP_VERSION,
            selectedSection: 'charts',
            pervSection: 'charts',
        };
    },
    created (){
        bus.$on('settingsPopupClosed', () => {
            this.selectedSection = this.pervSection;
        });
    },
    methods: {
        toggleExpand(event) {
            event.preventDefault();
            this.expanded = !this.expanded;
        },
        logout() {
            this.$store.dispatch('authentication/logout');
            this.$router.push('/auth');
        },
        openSettings(){
            this.pervSection = this.selectedSection;
            this.selectedSection = 'settings';
            bus.$emit('openSettingsPopup');
        }
    },
};

</script>

<style lang="scss">
    @import '../../style/layout/Sidebar.scss';
</style>
